import React from 'react';
import { path } from 'ramda';
import { compose, withHandlers, withProps } from 'recompose';
import { t } from '../../../../modules/infra/i18n';
import withToggle from '../../hoc/withToggle';
import RefundModal from '../components/RefundModal';
import ReturnItemMessage from '../components/ReturnItemMessage';
import confirmModal from '../../../common/confirmModal';
import { ITEM_TYPE } from '../../../register/constants';

const shouldShowReturnedByCustomerModal = sale => (
  sale.itemType === ITEM_TYPE.product
);

const RefundModalContainer = compose(
  withProps((props) => {
    let tipAmount = 0;
    const payment = path(['item', 'payments', 0], props);
    if (payment) {
      tipAmount = Math.max(0, payment.tip - payment.tipRefunded);
    }

    return {
      maxRefundAmount: props.item.maxRefundAmount,
      totalAmount: props.item.totalCost - tipAmount,
      hasTip: tipAmount > 0,
      paymentId: payment ? payment.id : '',
      tipAmount,
    };
  }),
  withHandlers({
    askIfItemReturned: () => (item) => {
      return new Promise((resolve) => {
        if (!shouldShowReturnedByCustomerModal(item)) {
          resolve(false);
          return;
        }

        confirmModal(
          {
            message: <ReturnItemMessage />, // eslint-disable-line
            type: 'yesno',
            confirmButtonText: t('common:refund_modal.yes_button'),
            negativeButtonText: t('common:refund_modal.no_button'),
          },
          () => resolve(true),
          () => resolve(false),
        );
      });
    },
  }),
  withHandlers({
    maxRefund: props => async () => {
      const itemReturned = await props.askIfItemReturned(props.item);
      return props.refund(props.item, { amount: props.maxRefundAmount, itemReturned }).then(props.close);
    },
    refundCustom: props => async (amount) => {
      const itemReturned = await props.askIfItemReturned(props.item);
      return props.refund(props.item, { amount, itemReturned }).then(props.close);
    },
    refundTip: props => () => props.refund(props.item, {
      payments: [{ id: props.paymentId, tipAmount: props.tipAmount }],
    }),
  }),
  withToggle('customAmount'),
);

export default RefundModalContainer(RefundModal);
